"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayable = displayable;

function displayable(field) {
  var _field$properties$lab;

  return (_field$properties$lab = field.properties.label) !== null && _field$properties$lab !== void 0 ? _field$properties$lab : field.name;
}